import { useState, type ReactNode } from 'react';
import type { CanvasChatMessage } from '@/pages/canvas/canvas-types';
import { ChatToolProgressCard } from './ChatToolProgressCard';
import { PlaybookTaskCard } from './PlaybookTaskCard';
import { summarizeCanvasProgress } from '@/pages/canvas/canvas-progress-summary';
import { ChatThinkingLabel } from '@/pages/canvas/canvas-chat-status';

/** Tool and playbook events describe the same request. Upgrade its existing
 * card in place, keeping disclosure state local to this message/run. */
export function CanvasRunProgressCard({ message, isActive, queueContent, waiting = false }: { message: CanvasChatMessage; isActive: boolean; queueContent?: ReactNode; waiting?: boolean }) {
  const [expanded, setExpanded] = useState(true);
  const hasImageGallery = message.imageSlots?.some(slot => !slot.failed && !!slot.resolved)
    || (!message.imageSlots?.length && !!message.thumbnails?.length);
  const hasTile = !waiting && (!!message.playbookProgress || !!message.agentTaskGroups?.length);
  const status = isActive ? '' : summarizeCanvasProgress(message, false)[0];
  const hideCompletedStatus = hasImageGallery && (status === 'Recorded work is complete.' || status === 'Ad concepts are ready.');
  return <div data-testid={`canvas-run-progress-${message.id}`}>
    {(hasTile && (isActive || !hideCompletedStatus)) && <div role="status" style={{ display: "flex", alignItems: "center", gap: 12, fontSize: 13, color: "#777b80", marginBottom: 8 }}>
      {isActive ? <span><ChatThinkingLabel /></span> : !hideCompletedStatus && <span>{status}</span>}
    </div>}
    <div id={`run-process-${message.id}`}>{!hasTile ? (
      queueContent && <div data-testid="queued-process-tile" style={{background:"#eceef3",borderRadius:24,padding:"20px 24px",margin:"12px 0"}}>{queueContent}</div>
    ) : message.playbookProgress ? (
      <PlaybookTaskCard progress={message.playbookProgress} messageId={message.id}
        messageImageSlots={message.imageSlots} isActive={isActive}
        showThumbnails={!hasImageGallery}
        footer={queueContent} expanded={expanded} onExpandedChange={setExpanded} />
    ) : (
      <ChatToolProgressCard groups={message.agentTaskGroups ?? []} isStreaming={isActive}
        footer={queueContent} expanded={expanded} onExpandedChange={setExpanded} />
    )}</div>
  </div>;
}
